import { useQuery } from 'react-query';

import { getUsers } from '../Services/Api';

const useUsersQuery = (
  key: any,
  { post, limit, page = 0, filter, search = '', sort, useQueryProps }: any,
) => {
  const { data, ...params } = useQuery(
    [key, page, post, filter, search, sort],
    () =>
      getUsers({
        limit,
        page,
        filter,
        sort,
        search,
      }),
    {
      enabled: !!window.spaceSlug,
      select: (response: any) => response.data,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      ...useQueryProps,
    },
  );

  return {
    users: data?.data || [],
    paging: data?.paging || { total: 0 },
    usersCount: data?.paging?.total || 0,
    ...params,
  };
};

export default useUsersQuery;
